/*
 ** ProductionLine
 */
import AllProductionComponents from '../../../config/components/line/ante/allcomponentsexport';

/* Components which are supposed to be the the same along all projects */
import CommonComponentsExport from '../../../config/components/line/common/commoncomponentsexport';

const wiehag_config = {
  /* Define Boxes to be shown in production line screen - Dashboard */
  components: [
    [
      { RawInfeedLoadingBox: { title: 'vacuumTitle', componentPath: 'importedcomponents' } },
      { ZincBox: { title: 'zincTitle', componentPath: 'importedcomponents' } },
      { EtageLagerBox: { title: 'etageLagerTitle', componentPath: 'importedcomponents' } }
    ]
  ],

  /* Importing all components needed from project unique subfolder with components */
  importedcomponents: AllProductionComponents,
  commoncomponents: CommonComponentsExport
};

export default wiehag_config;
